import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import About from "./pages/About";
import Contact from "./pages/Contact";
import OrderTracking from "./pages/OrderTracking";
import ShippingReturns from "./pages/ShippingReturns";
import CGV from "./pages/legal/CGV";
import Mentions from "./pages/legal/Mentions";
import Privacy from "./pages/legal/Privacy";
import Cookies from "./pages/legal/Cookies";
import Wishlist from "./pages/Wishlist";
import Parrainage from "./pages/Parrainage";
import NewsletterPopup from "./components/NewsletterPopup";
import AnalyticsTracker from "./components/AnalyticsTracker";
import TopAnnouncementBar from "./components/TopAnnouncementBar";
import CookieConsentBanner from "./components/CookieConsentBanner";
import CartDrawerNotification from "./components/CartDrawerNotification";
import ExitIntentPopup from "./components/ExitIntentPopup";
import ScrollToTop from "./components/ScrollToTop";

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-sm text-[#525252]">Chargement...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function Layout({ children }) {
  return (
    <>
      <TopAnnouncementBar />
      <Header />
      <main>{children}</main>
      <Footer />
      <NewsletterPopup />
      <CookieConsentBanner />
      <CartDrawerNotification />
      <ExitIntentPopup />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <WishlistProvider>
              <Toaster position="top-center" richColors />
              <AnalyticsTracker />
              <ScrollToTop />
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/tracking" element={<OrderTracking />} />
                  <Route path="/shipping" element={<ShippingReturns />} />
                  <Route path="/legal/cgv" element={<CGV />} />
                  <Route path="/legal/mentions" element={<Mentions />} />
                  <Route path="/legal/privacy" element={<Privacy />} />
                  <Route path="/legal/cookies" element={<Cookies />} />
                  <Route path="/parrainage" element={<Parrainage />} />
                  <Route
                    path="/account"
                    element={
                      <ProtectedRoute>
                        <Account />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute role="admin">
                        <Admin />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Layout>
            </WishlistProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
